/* eslint-disable no-use-before-define */
import React from 'react'
import { Fields, isEmpty, arrayRemove, getId, } from '../twd'

export default ({
    name, form, cls='', error, prefix='', suffix='',
    options=[],
    emptyText='Any',
    allText='All',
    remove, push,
    style, label,
    listConfig,
    inputConfig,
    optionCheckboxLabelConfig,
    dataName='twd-fields-select-multi',
    showSelectAll=false,
    isMultiSelect=true,
    id:id_,
    placeholder = getPlaceHolder,
    onBlur,
    onFocus,
    disabled=false,
    ...props
} = {}) => {

    let err = form && form.errors && form.errors[name]
    let values = (form && form.values[name]) || props.values || []

    let chg = props.onSelect
        || ((a) => {
            let v = a.value
            if (showSelectAll && v==='*') {
                let isAll = values.length>0 && values.length===options.length
                if (isAll) {
                    [...values]
                    .forEach(a => arrayRemove(values, a))

                    form.setFieldValue(name, values)
                }
                else {
                    options
                    .map(a => a.value)
                    .filter(a => values.indexOf(a)<0)
                    .forEach(a => push(a))
                }
                return
            }

            let i = values.indexOf(v)
            if (i>=0) {
                arrayRemove(values, v)
                options
                .filter(a => a.oneOf===v)
                .forEach(a => arrayRemove(values, a.value))

                form.setFieldValue(name, values)
            }
            else {
                push(v)
                let b = a.oneOf
                if (b && values.indexOf(b)<0) {
                    push(b)
                }
            }
        })

    let id = id_ || getId()
    return <React.Fragment>
        {label && <label style={{whiteSpace:'nowrap'}} htmlFor={id}>{label}</label>}

        <div
            className={ 'form-group' + (err || error ? ' has-error': '')}
            style={Object.assign({whiteSpace:'nowrap'},style)}
        >
        <Fields.Search
            id={id}
            dataName={dataName}
            placeholder={placeholder({values, options, emptyText, allText})}
            type="select"
            listConfig={listConfig}
            inputConfig={{
                ...inputConfig,
                role:'list',
                ...(err || error ? {"aria-invalid":true} : {}),
            }}
            onSelect={chg}
            onBlur={onBlur}
            onFocus={onFocus}
            multiple={isMultiSelect}
            disabled={disabled}
        >{({keyword:text}) => {
            return <Options
                text={text}
                values={values}
                options={options}
                showSelectAll={showSelectAll}
                isMultiSelect={isMultiSelect}
                optionCheckboxLabelConfig={optionCheckboxLabelConfig}
                />
        }}</Fields.Search>
        </div>

        </React.Fragment>
}

const getPlaceHolder = ({emptyText, allText, values, options}) => {
    let isNone = isEmpty(values)
    if (isNone) return emptyText

    let isAll = values.length>0 && values.length === options.length
    if (isAll) return allText

    let selected = options
        .filter(a => values.indexOf(a.value)>=0)

    let n = selected.length
    if (n===0) return emptyText

    let s = selected[0]
    let t = s.label
        + (n > 1 ? ` + ${n-1} selected` : '')
    return t
}

const Options = ({
    text, values, options,
    optionCheckboxLabelConfig,
    dataName='twd-fields-select-multi',
    isMultiSelect=true,
    showSelectAll=false
} = {}) => {
    let isAll = values.length === options.length

    return <React.Fragment>
    { showSelectAll && <React.Fragment>
            <Fields.SearchOption
                dataName={dataName + '-option-select-all'}
                item={{value:'*'}}
            >
            <Fields.CheckboxLabel
                dataName={dataName + '-option-select-all-checkbox'}
                checkboxStyle={{marginLeft: ''}}
                checked={isAll ? true: false}
                aria-hidden={true}
                label="Select all" />
            </Fields.SearchOption>
            <hr aria-hidden="true" />
        </React.Fragment>}
    {
        getOptions({text, values, options}).map((a,i) => {
            let checked = values.indexOf(a.value)>=0
            return (
            <Fields.SearchOption
                dataName={dataName + '-option'}
                item={a} key={i}>
            <Fields.CheckboxLabel
                dataName={dataName + '-option-checkbox'}
                checkboxStyle={{marginLeft: a.oneOf ? '20px': ''}}
                checked={checked}
                aria-hidden={true}
                label={a.label}
                showCheckbox={isMultiSelect}
                {...optionCheckboxLabelConfig}
            />
            </Fields.SearchOption>
            )
        })
    }
    </React.Fragment>
}

const getOptions = ({text='', values=[], options=[]} = {}) => {
    let t = text.toLowerCase()
    return options
        .map(a => Object.assign({...a}, {
            selected: values.indexOf(a.value)>=0
        }))
        .filter(a => !text
            || a.label.toLowerCase().indexOf(t) >= 0)
}



// WEBPACK FOOTER //
// ./src/twd/fields/select-multi.js